// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"9ea89b8f","952":"93cdd13f"}[chunkId] + ".chunk.js";
};